/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  PriceSummaryDto,
  QuantityDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { projectAPIBuilder } from './BoMAsyncActions'
import { fetchProject } from './fetchProject'

const SaveCostDriverDiscountRatio = createAsyncThunk<any, any, { state: any }>(
  'priceSummary/SaveCostDriverDiscountRatio',
  async (
    {
      newRatio,
      priceSummary,
    }: { newRatio: QuantityDto; priceSummary: PriceSummaryDto },
    thunkAPI
  ) => {
    const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

    try {
      if (priceSummary.isMaterial) {
        return await api.SetArticleDiscountRatio(
          projectId,
          priceSummary.materialId,
          {
            ...priceSummary.discountRatio,
            value: newRatio.value,
          }
        )
      } else if (priceSummary?.isWorkingStep) {
        return await api.SetResourceDiscountRatio(
          projectId,
          priceSummary.workingStep.resource.id,
          priceSummary.workingStep.primaryWorkingStep,
          priceSummary.workingStep.secondaryWorkingStep,
          {
            ...priceSummary.discountRatio,
            value: newRatio.value,
          }
        )
      }
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)

const SaveCostDriverSurchargeRatio = createAsyncThunk<any, any, { state: any }>(
  'priceSummary/SaveCostDriverSurchargeRatio',
  async (
    {
      newRatio,
      priceSummary,
    }: { newRatio: QuantityDto; priceSummary: PriceSummaryDto },
    thunkAPI
  ) => {
    const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

    try {
      if (priceSummary.isMaterial) {
        return await api.SetArticleSurchargeRatio(
          projectId,
          priceSummary.materialId,
          {
            ...priceSummary.surchargeRatio,
            value: newRatio.value,
          }
        )
      } else if (priceSummary?.isWorkingStep) {
        return await api.SetResourceSurchargeRatio(
          projectId,
          priceSummary.workingStep.resource.id,
          priceSummary.workingStep.primaryWorkingStep,
          priceSummary.workingStep.secondaryWorkingStep,
          {
            ...priceSummary.surchargeRatio,
            value: newRatio.value,
          }
        )
      }
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)

const ResetCostDriverDiscountToDefault = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'priceSummary/resetCostDriverDiscountToDefault',
  async ({ priceSummary }: { priceSummary: PriceSummaryDto }, thunkAPI) => {
    const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

    try {
      if (priceSummary.isMaterial) {
        return await api.DeleteArticleDiscount(
          projectId,
          priceSummary.materialId
        )
      } else if (priceSummary?.isWorkingStep) {
        return await api.DeleteResourceDiscount(
          projectId,
          priceSummary.workingStep.resource.id,
          priceSummary.workingStep
        )
      }
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)

const ResetCostDriverSurchargeToDefault = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'priceSummary/ResetCostDriverSurchargeToDefault',
  async ({ priceSummary }: { priceSummary: PriceSummaryDto }, thunkAPI) => {
    const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

    try {
      if (priceSummary.isMaterial) {
        return await api.DeleteArticleSurcharge(
          projectId,
          priceSummary.materialId
        )
      } else if (priceSummary?.isWorkingStep) {
        return await api.DeleteResourceSurcharge(
          projectId,
          priceSummary.workingStep.resource.id,
          priceSummary.workingStep
        )
      }
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)

export const CostDriversActions = {
  SaveCostDriverDiscountRatio,
  ResetCostDriverDiscountToDefault,
  SaveCostDriverSurchargeRatio,
  ResetCostDriverSurchargeToDefault,
}
